export const MANAGEVOUCHER = 'MANAGEVOUCHER'